module.exports = __webpack_public_path__ + "static/media/grammarly_ai.f8f53a1c.png";